import React, { Dispatch, FC } from "react";
import { t } from "i18next";

import { Avatar } from "../atoms/Avatar";
import { Modal } from "./Modal";

export type ProfileListModalProps = {
  visible?: boolean;
  setVisible: Dispatch<boolean>;
  profiles?: Array<any>;
  onSelectProfile: (profile: any) => void;
};

export const ProfileListModal: FC<ProfileListModalProps> = ({
  visible,
  setVisible,
  profiles,
  onSelectProfile,
}) => {
  return (
    <Modal
      open={!!visible}
      Close={() => setVisible(false)}
      tittleModal={t("auth.title_profile")}
      textButtonClose={t("general.cancel")}
    >
      <div className="flex flex-col gap-4 mt-10">
        {profiles?.map((profile) => {
          return (
            <div
              key={profile.id}
              className="flex mb-2 gap-4 cursor-pointer border-b border-gray-100 pb-2 px-2 rounded-lg"
              onClick={() => onSelectProfile(profile)}
            >
              <div className="flex items-center">
                <Avatar
                  src={profile.avatar}
                  style={{ height: 50, width: 50 }}
                />
              </div>
              <div className="flex flex-col">
                <p>{profile?.name}</p>
                <p>{profile?.branch?.branch}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
};
